import { API } from "./api";

export interface SetupSystem {
  id: number;
  name: string;
  system_type: string;
}
export interface SystemRevision extends SetupSystem {
  system_id: number;
  config_revision_id: number;
}
export const linkageLabels = {
  system_a_additional_attribute_id: "System A contact linkage attribute",
  system_b_additional_attribute_id: "System B contact linkage attribute",
  system_a_account_additional_attribute_id:
    "System A account linkage attribute",
  system_b_account_additional_attribute_id:
    "System B account linkage attribute",
};
export type LinkageField = keyof typeof linkageLabels;
export interface SetupGroup {
  id: number;
  system_a: SetupSystem;
  system_b: SetupSystem;
  attributes: Record<
    LinkageField,
    {
      id: number | null;
      label: string | null;
      available: boolean;
      applicable: boolean;
    }
  >;
  reference_limits: boolean;
  max_reference_data_searches: number;
  max_reference_data_refreshes: number;
}
export interface GroupConfigurations {
  groups: SetupGroup[];
  system_revisions: SystemRevision[];
}
export interface SetupPair {
  system_a_id: number;
  system_b_id: number;
  kind: string;
  attribute_fields: LinkageField[];
  required_attribute_fields: LinkageField[];
  reference_limits: boolean;
}
export interface CreationOptions {
  systems: SetupSystem[];
  pairs: SetupPair[];
  attributes: {
    id: number;
    system_id: number;
    entity: string;
    label: string;
  }[];
  defaults: {
    max_reference_data_searches: number;
    max_reference_data_refreshes: number;
  };
}
export type CreateGroup = {
  system_a_id: number;
  system_b_id: number;
  max_reference_data_searches?: number;
  max_reference_data_refreshes?: number;
} & Partial<Record<LinkageField, number>>;
export async function getGroupConfigurations(): Promise<GroupConfigurations> {
  return (await API.get("/get-sync-group-configurations")).data;
}
export async function getGroupCreationOptions(): Promise<CreationOptions> {
  return (await API.get("/get-sync-group-creation-options")).data;
}
export async function createSyncGroup(
  values: CreateGroup
): Promise<{ sync_group_id: number }> {
  return (await API.post("/add-sync-group", values)).data;
}
